var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsEdit = function SvgSmsEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8 13.666H4.667c-2 0-3.333-1-3.333-3.333V5.666c0-2.333 1.333-3.333 3.333-3.333h6.667c2 0 3.333 1 3.333 3.333v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.333 6 9.246 7.667c-.686.546-1.813.546-2.5 0L4.667 6M12.807 9.847l-2.36 2.36a.8.8 0 0 0-.2.393l-.127.9c-.047.327.18.553.507.507l.9-.127a.8.8 0 0 0 .393-.2l2.36-2.36c.407-.406.6-.88 0-1.48-.593-.593-1.067-.4-1.473.007"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.467 10.187c.2.72.76 1.28 1.48 1.48"
  })));
};
export default SvgSmsEdit;